import * as S from './styles';

export function Gift({ brinde, onClick }) {
  return (
    <S.Container className="gift" onClick={onClick}>
      <div className="gift-top">
        <span>{brinde.quantidade} unid.</span>
        <strong>+ brinde</strong>
      </div>
      <span className="gift-bottom">Comprar</span>
    </S.Container>
  );
}
